import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';
import { Observable, EMPTY, timer } from 'rxjs';
import { switchMap } from 'rxjs/operators';

/**
 * Downloads the code of routes marked `data: { preload: true }` in the background, shortly
 * after the app starts (e.g. while the user is on the login page). Entering the portal after
 * login is then near-instant instead of waiting for ~230 KB of code to download.
 *
 * Only the portal shell and landing pages are marked, so users don't download every screen.
 * Skipped on slow / data-saver connections.
 */
@Injectable({ providedIn: 'root' })
export class SelectivePreloadingStrategy implements PreloadingStrategy {
  preload(route: Route, load: () => Observable<any>): Observable<any> {
    if (!route.data?.['preload'] || this.isConstrainedConnection()) {
      return EMPTY;
    }
    // Small delay so the current page renders first
    return timer(1500).pipe(switchMap(() => load()));
  }

  private isConstrainedConnection(): boolean {
    const conn = (globalThis.navigator as any)?.connection;
    if (!conn) return false;
    return !!conn.saveData || /(^|-)2g$/.test(conn.effectiveType || '');
  }
}
